// extracted by mini-css-extract-plugin
export default {"registrationButtonSpacing":"FycVJ","registrationButtonSpacing--noImage":"ddNa8","registrationButtonSpacingNoImage":"ddNa8"};